<template>
    <section class="container-result-card">
        <div class="status-value" :style="{ 'background': data.bg_color || data.color}" />

        <div class="content-result-card">
            <span class="title">{{ title }}</span>

            <div class="value-percent">
                <span class="value">{{ data.value }}</span>
                <span class="percent"> / {{ data.percent }}%</span>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'ui-product-result-card',

        props: {
            data: {
                type: Object,
                default: () => {}
            }
        },

        computed: {
            title() {
                return this.data.label == 'Reserva Permanente' ? 'Permanente' : this.data.label
            }
        }
    }
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>